export const routing = {
    name: 'routing',
    state: {
        pathname: '',
        search: '',
    },
    reducers: {
        setLocation(state, payload) {
            return {
                ...state,
                pathname: payload.pathname,
                search: payload.search,
            };
        },
    },
    effects: (dispatch) => ({
        updateLocation(payload) {
            dispatch.routing.setLocation(payload);
        },
    }),
};
